export default {
  placeholder: 'Que cherchez-vous ? ...',
  resetFilters: 'Tout effacer'
}
